var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIconInChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.25,
    height: 91,
    viewBox: "0 0 68.25 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2d2756;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.813,24.172V0H4.266A4.255,4.255,0,0,0,0,4.266V86.734A4.255,4.255,0,0,0,4.266,91H63.984a4.255,4.255,0,0,0,4.266-4.266v-58.3H44.078A4.278,4.278,0,0,1,39.813,24.172ZM68.25,21.666V22.75H45.5V0h1.084a4.262,4.262,0,0,1,3.021,1.244l17.4,17.418A4.252,4.252,0,0,1,68.25,21.666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconInChat);
export default __webpack_public_path__ + "static/media/file-icon-in-chat.ba32acc99c1ea7cfba00f3d982f1d968.svg";
export { ForwardRef as ReactComponent };